module.exports = __webpack_public_path__ + "static/img/contact_code.42feedc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact_code.png
// module id = chP5
// module chunks = 0